var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAnchorSimple = function SvgIconAnchorSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.25 6A3.25 3.25 0 0 1 13 9.093v10.094a8 8 0 0 0 6.937-6.937H18.75a1 1 0 1 1 0-2H21a1 1 0 0 1 1 1 10 10 0 0 1-20 0 1 1 0 0 1 1-1h2.25a1 1 0 1 1 0 2H4.063A8 8 0 0 0 11 19.187V9.093a3.251 3.251 0 0 1 1-6.343A3.25 3.25 0 0 1 15.25 6M12 4.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconAnchorSimple;